import { useSession } from "next-auth/react";
import React from "react";
import { PostEditCTAButton } from "~/components/PostEditCTA/PostEditCTAButton";
import { Body } from "~/ui-library";
import { ControlledPostEditCTA } from "./ControlledPostEditCTA";

export type PostEditCTAProps = {
  postParam: string | number;
  startContent?: React.ReactNode;
};

export const PostEditCTA: React.FC<PostEditCTAProps> = ({
  postParam,
  startContent,
}) => {
  const { data: session } = useSession();
  return (
    <ControlledPostEditCTA
      isVisible={!!session?.user.isCmsUser}
      endContent={
        <div className="flex items-center">
          <Body className="mr-xs" size="small">
            Need to make changes?
          </Body>
          <PostEditCTAButton postParam={postParam}>
            Edit This Page
          </PostEditCTAButton>
        </div>
      }
      startContent={startContent}
    />
  );
};
